// AUTO-GENERATED from `oak_large.json` — do not edit by hand. Regenerate via the preset
//   → `.ts` conversion script when the upstream preset JSONs change.
import type {DeepPartial, TreeOptions} from "../options.js";

const options: DeepPartial<TreeOptions> = {
    "seed": 23399,
    "type": "deciduous",
    "bark": {
      "type": "Bark001",
      "tint": 16774097,
      "flatShading": false,
      "textured": true,
      "textureScale": {
        "x": 1,
        "y": 10
      }
    },
    "branch": {
      "levels": 3,
      "angle": {
        "1": 54,
        "2": 43,
        "3": 32
      },
      "children": {
        "0": 9,
        "1": 5,
        "2": 3
      },
      "force": {
        "direction": {
          "x": 0,
          "y": 1,
          "z": 0
        },
        "strength": 0.02
      },
      "gnarliness": {
        "0": -0.04,
        "1": 0.16,
        "2": -0.06,
        "3": 0.09
      },
      "length": {
        "0": 47.7,
        "1": 29.39,
        "2": 17.62,
        "3": 7.16
      },
      "radius": {
        "0": 3,
        "1": 0.69,
        "2": 0.69,
        "3": 1.19
      },
      "sections": {
        "0": 16,
        "1": 9,
        "2": 8,
        "3": 3
      },
      "segments": {
        "0": 12,
        "1": 5,
        "2": 3,
        "3": 3
      },
      "start": {
        "1": 0.35,
        "2": 0.1,
        "3": 0.0
      },
      "taper": {
        "0": 0.73,
        "1": 0.42,
        "2": 0.69,
        "3": 0.75
      },
      "twist": {
        "0": -0.23,
        "1": 0.42,
        "2": 0,
        "3": 0
      }
    },
    "leaves": {
      "type": "oak",
      "billboard": "double",
      "angle": 36,
      "count": 10,
      "start": 0.16,
      "size": 4.5,
      "sizeVariance": 0.7,
      "tint": 14013901,
      "alphaTest": 0.5
    },
    "trellis": {
      "enabled": false
    }
  };

export default options;
